import { c as _c } from "react/compiler-runtime";
import { Input } from "@repo/ui/components/ui/input";
import { CheckCircle, ImageIcon, Loader2, X } from "lucide-react";
import { useMediaManager } from "@/lib/hooks/useMediaManager";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MediaManager(t0) {
  const $ = _c(18);
  const {
    items,
    onChange
  } = t0;
  const manager = useMediaManager(items, onChange);
  let t1;
  if ($[0] !== items || $[1] !== manager.remove || $[2] !== manager.setAltText || $[3] !== manager.setPrimary || $[4] !== manager.uploading) {
    t1 = (items.length > 0 || manager.uploading.length > 0) && /*#__PURE__*/_jsx(MediaGrid, {
      items: items,
      uploading: manager.uploading,
      onRemove: manager.remove,
      onSetPrimary: manager.setPrimary,
      onAltTextChange: manager.setAltText
    });
    $[0] = items;
    $[1] = manager.remove;
    $[2] = manager.setAltText;
    $[3] = manager.setPrimary;
    $[4] = manager.uploading;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = items.length > 0;
  let t3;
  if ($[6] !== manager) {
    t3 = files => manager.handleFiles(files);
    $[6] = manager;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== manager.dragActive || $[9] !== manager.dragHandlers || $[10] !== manager.inputRef || $[11] !== manager.openFilePicker || $[12] !== t2 || $[13] !== t3) {
    t4 = /*#__PURE__*/_jsx(DropZone, {
      hasImages: t2,
      dragActive: manager.dragActive,
      inputRef: manager.inputRef,
      onOpenPicker: manager.openFilePicker,
      onFileChange: t3,
      dragHandlers: manager.dragHandlers
    });
    $[8] = manager.dragActive;
    $[9] = manager.dragHandlers;
    $[10] = manager.inputRef;
    $[11] = manager.openFilePicker;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-3",
      children: [t1, t4]
    });
    $[15] = t1;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}

// ─── Sub-components ─────────────────────────────────────────────────────────

function MediaGrid(t0) {
  const $ = _c(14);
  const {
    items,
    uploading,
    onRemove,
    onSetPrimary,
    onAltTextChange
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== onAltTextChange || $[2] !== onRemove || $[3] !== onSetPrimary) {
    let t2;
    if ($[5] !== onAltTextChange || $[6] !== onRemove || $[7] !== onSetPrimary) {
      t2 = (item, i) => /*#__PURE__*/_jsx(MediaCard, {
        item: item,
        onRemove: () => onRemove(i),
        onSetPrimary: () => onSetPrimary(i),
        onAltTextChange: text => onAltTextChange(i, text)
      }, item.url);
      $[5] = onAltTextChange;
      $[6] = onRemove;
      $[7] = onSetPrimary;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = onAltTextChange;
    $[2] = onRemove;
    $[3] = onSetPrimary;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== uploading) {
    t2 = uploading.map(_temp);
    $[9] = uploading;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = /*#__PURE__*/_jsxs("div", {
      className: "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5",
      children: [t1, t2]
    });
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
function _temp(u) {
  return /*#__PURE__*/_jsx(UploadingCard, {
    file: u
  }, u.id);
}
function MediaCard(t0) {
  const $ = _c(26);
  const {
    item,
    onRemove,
    onSetPrimary,
    onAltTextChange
  } = t0;
  let t1;
  if ($[0] !== item.altText || $[1] !== item.url) {
    t1 = /*#__PURE__*/_jsx("img", {
      src: item.url,
      alt: item.altText,
      className: "h-full w-full object-cover"
    });
    $[0] = item.altText;
    $[1] = item.url;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx(X, {
      className: "h-3.5 w-3.5"
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onRemove) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: "absolute right-1 top-1 flex gap-1 opacity-0 transition-opacity group-hover:opacity-100",
      children: /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onRemove,
        className: "rounded-full bg-red-500 p-1 text-white hover:bg-red-600",
        children: t2
      })
    });
    $[4] = onRemove;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== item.isPrimary) {
    t4 = item.isPrimary && /*#__PURE__*/_jsxs("div", {
      className: "absolute bottom-1 right-1 flex items-center gap-0.5 rounded-full bg-brand px-1.5 py-0.5 text-[10px] font-medium text-white",
      children: [/*#__PURE__*/_jsx(CheckCircle, {
        className: "h-3 w-3"
      }), "Prim\xE4r"]
    });
    $[6] = item.isPrimary;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "relative aspect-[4/3]",
      children: [t1, t3, t4]
    });
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onAltTextChange) {
    t6 = e => onAltTextChange(e.target.value);
    $[12] = onAltTextChange;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== item.altText || $[15] !== t6) {
    t7 = /*#__PURE__*/_jsx(Input, {
      type: "text",
      placeholder: "Alt-text",
      value: item.altText,
      onChange: t6,
      className: "h-7 text-xs"
    });
    $[14] = item.altText;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== item.isPrimary || $[18] !== onSetPrimary) {
    t8 = !item.isPrimary && /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onSetPrimary,
      className: "text-[11px] text-brand hover:underline",
      children: "G\xF6r till prim\xE4r"
    });
    $[17] = item.isPrimary;
    $[18] = onSetPrimary;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-1 p-2",
      children: [t7, t8]
    });
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t5 || $[24] !== t9) {
    t10 = /*#__PURE__*/_jsxs("div", {
      className: "group relative overflow-hidden rounded-lg border bg-white",
      children: [t5, t9]
    });
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function UploadingCard(t0) {
  const $ = _c(6);
  const {
    file
  } = t0;
  let t1;
  if ($[0] !== file.name || $[1] !== file.previewUrl) {
    t1 = /*#__PURE__*/_jsx("img", {
      src: file.previewUrl,
      alt: file.name,
      className: "h-full w-full object-cover opacity-50"
    });
    $[0] = file.name;
    $[1] = file.previewUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx("div", {
      className: "absolute inset-0 flex items-center justify-center",
      children: /*#__PURE__*/_jsx(Loader2, {
        className: "h-6 w-6 animate-spin text-brand"
      })
    });
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: "relative overflow-hidden rounded-lg border",
      children: /*#__PURE__*/_jsxs("div", {
        className: "relative aspect-[4/3]",
        children: [t1, t2]
      })
    });
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function DropZone(t0) {
  const $ = _c(17);
  const {
    hasImages,
    dragActive,
    inputRef,
    onOpenPicker,
    onFileChange,
    dragHandlers
  } = t0;
  const t1 = `flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed p-6 transition-colors ${dragActive ? "border-brand bg-brand/5" : "border-gray-300 hover:border-brand/50"}`;
  let t2;
  if ($[0] !== onOpenPicker) {
    t2 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onOpenPicker();
      }
    };
    $[0] = onOpenPicker;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(ImageIcon, {
      className: "mb-2 h-8 w-8 text-gray-400"
    });
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = hasImages ? "L\xE4gg till fler bilder" : "Dra och sl\xE4pp bilder, eller klicka f\xF6r att v\xE4lja";
  let t5;
  if ($[3] !== t4) {
    t5 = /*#__PURE__*/_jsx("p", {
      className: "text-sm text-gray-500",
      children: t4
    });
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onFileChange) {
    t6 = e_0 => {
      if (e_0.target.files) {
        onFileChange(e_0.target.files);
      }
    };
    $[5] = onFileChange;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== inputRef || $[8] !== t6) {
    t7 = /*#__PURE__*/_jsx("input", {
      ref: inputRef,
      type: "file",
      accept: "image/*",
      multiple: true,
      className: "hidden",
      onChange: t6
    });
    $[7] = inputRef;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== dragHandlers || $[11] !== onOpenPicker || $[12] !== t1 || $[13] !== t2 || $[14] !== t5 || $[15] !== t7) {
    t8 = /*#__PURE__*/_jsxs("div", {
      role: "button",
      tabIndex: 0,
      className: t1,
      onClick: onOpenPicker,
      onKeyDown: t2,
      ...dragHandlers,
      children: [t3, t5, t7]
    });
    $[10] = dragHandlers;
    $[11] = onOpenPicker;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}